<mat-icon [class.spinner]="spinnerIf">
  <ng-container *ngIf="spinnerIf; else content">
    cached
  </ng-container>
  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>
</mat-icon>
